var chunkMapping = {
	"208": [
		80208
	],
	"344": [
		50344
	],
	"396": [
		20396
	],
	"424": [
		60424
	],
	"2345": [
		12345
	],
	"2625": [
		72625
	],
	"3338": [
		53338
	],
	"4173": [
		34173
	],
	"4307": [
		74307
	],
	"4803": [
		44803
	],
	"6693": [
		26693
	],
	"7081": [
		67081
	],
	"7228": [
		27228
	],
	"8411": [
		18411
	],
	"8579": [
		88579
	],
	"8713": [
		38713
	],
	"9228": [
		19228
	]
};
var idToExternalAndNameMapping = {
	"12345": [
		"default",
		"./WorkspaceMgmtRoutes",
		38960
	],
	"18411": [
		"default",
		"./UserActions",
		67831
	],
	"19228": [
		"default",
		"./UserProfile",
		18081
	],
	"20396": [
		"default",
		"./Module",
		64921
	],
	"26693": [
		"default",
		"./Subscriptions",
		80417
	],
	"27228": [
		"default",
		"./FileMgmtRoutes",
		76800
	],
	"34173": [
		"default",
		"./AdminDashboard",
		70611
	],
	"38713": [
		"default",
		"./AssistantWidget",
		59395
	],
	"44803": [
		"default",
		"./UserRequests",
		51026
	],
	"50344": [
		"default",
		"./GlobalNavigation",
		90767
	],
	"53338": [
		"default",
		"./App",
		3887
	],
	"60424": [
		"default",
		"./AdminPanel",
		88434
	],
	"67081": [
		"default",
		"./UnifiedBriefing",
		34447
	],
	"72625": [
		"default",
		"./AiOverviewWidget",
		44324
	],
	"74307": [
		"default",
		"./IntbriefWidget",
		26910
	],
	"80208": [
		"default",
		"./HubsApp",
		85176
	],
	"88579": [
		"default",
		"./UserEventsPanel",
		90140
	]
};
var idToRemoteMap = {
	"12345": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 38960
		}
	],
	"18411": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 67831
		}
	],
	"19228": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 18081
		}
	],
	"20396": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 64921
		}
	],
	"26693": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 80417
		}
	],
	"27228": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 76800
		}
	],
	"34173": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 70611
		}
	],
	"38713": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 59395
		}
	],
	"44803": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 51026
		}
	],
	"50344": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 90767
		}
	],
	"53338": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3887
		}
	],
	"60424": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 88434
		}
	],
	"67081": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 34447
		}
	],
	"72625": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 44324
		}
	],
	"74307": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 26910
		}
	],
	"80208": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 85176
		}
	],
	"88579": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 90140
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}